var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_c('FormTitleText',{attrs:{"titleText":_vm.$t('profile.lessonCourseInCharge')}})],1),_vm._l((_vm.lessonCourseNames),function(name,i){return _c('p',{key:i},[_vm._v(_vm._s(name))])})],2)}
var staticRenderFns = []

export { render, staticRenderFns }